<template>
  <gj-modal v-bind="$attrs" v-on="$listeners" :visible.sync="modalVisible" global size="full" no-padding>
    <template #header>
      <span>用户协议</span>
    </template>
    <template #content>
      <div class="up-container">
        <div class="up-editor">
          <p line="qY0R"><strong class="up-font-microsoftyahei">尊敬的积加用户，您好！</strong></p>
          <p line="LQ5B" class="ql-text-indent-1"><strong class="up-font-microsoftyahei">欢迎使用深圳市积加跨境网络科技有限公司
              (以下称“我们”)的积加ERP软件及服务！当您通过线上提交订购积加ERP软件产品的订单时，即视为您/贵公司不可撤销地同意与积加或其具备相应资质的销售商签订《积加ERP
              软件使用许可服务合同》，具体内容如下</strong></p>

          <p line="squp"><br></p>
          <p line="SodP"><strong class="up-font-microsoftyahei">一、您的权利义务</strong></p>
          <p line="Asql" class="ql-text-indent-1"><span
              class="up-font-microsoftyahei">1、您应确认系积加软件的最终用户，并保证向积加（含授权销售方，下同）提交的注册信息均真实、准确、及时、详尽和完整，并不断更新注册资料，以符合及时、详尽和准确的要求；您的注册信息不含有任何违反法律、法规及规范性文件，或侵犯他人合法权益的内容。</span>
          </p>
          <p line="0c9a" class="ql-text-indent-1"><span
              class="up-font-microsoftyahei">2、如您非正常使用积加软件（包括但不限于使用积加软件从事违法、违规活动），积加有权采取发出警告、暂时中止、永久终止您的用户身份，并保留对您追究相关法律责任的权利。</span>
          </p>
          <p line="NmGA" class="ql-text-indent-1"><span
              class="up-font-microsoftyahei">3、您须安排专门人员协助积加进行软件的实施工作，按积加提供的技术要求正确的使用软件。</span>
          </p>
          <p line="NmGA" class="ql-text-indent-1"><span class="up-font-microsoftyahei">4、您不得对软件进行非法拷贝及解密。</span>
          </p>
          <p line="NmGA" class="ql-text-indent-1"><span class="up-font-microsoftyahei">5、您按本合同规定的付款办法按时支付合同款项给乙方。</span>
          </p>
          <p line="NmGA" class="ql-text-indent-1"><span
              class="up-font-microsoftyahei">6、您应及时向积加免费提供双方一致确认的本项目实施所必要的技术数据、计算机设备、文档、文件、测试数据、示例输出, 或其它信息和资源。您应对其提供的所有该类数据、材料以及信息的内容、准确性、完整性和统一性负责，并承担由此产生的事故责任。</span>
          </p>
          <p line="NmGA" class="ql-text-indent-1"><span
              class="up-font-microsoftyahei">7、您应指派相应的人员组成项目组，并保证指派专门的人员负责执行本合同及其附件项下您的工作。在项目实施过程中，您应保证其项目组成员相对稳定。如果因您方人员变动导致本项目实施延误或增加积加的工作量（包括但不限于增加培训服务），积加对此延误不承担责任，并有权要求您支付乙方因此而增加工作量的服务费用。</span>
          </p>
          <p line="NmGA" class="ql-text-indent-1"><span
              class="up-font-microsoftyahei">8、我们的服务人员在您方现场工作期间，您方应免费为该顾问提供工作场所，并保证其可利用适当的您方的计算机资源和办公环境（包括电话、传真以及其它工作所必需的办公室设备和材料）。 </span>
          </p>
          <p line="NmGA" class="ql-text-indent-1"><span
              class="up-font-microsoftyahei">9、我方可以根据其自身的知识和经验对您方执行该任务提供相应的建议或帮助，但该建议或帮助不构成我方在本合同项下的任何义务或承诺。您方应根据其自身的判断进行决定并承担相应的责任。</span>
          </p>

          <p line="V4jS"><br></p>
          <p line="pMDD"><strong class="up-font-microsoftyahei">二、积加的权利义务</strong></p>
          <p line="NmGA" class="ql-text-indent-1"><span
              class="up-font-microsoftyahei">1、积加将通过线上为您提供免费售后服务，并在合同期内积加将为您提供服务支持，形式包括但不仅限于远程管理，电话，邮件，在线咨询等；并承诺工作日之工作时间内1个小时及时响应请求。</span>
          </p>
          <p line="NmGA" class="ql-text-indent-1"><span
              class="up-font-microsoftyahei">2、您允许积加通过亚马逊SP-API或MWS授权，浏览器插件、子账号等相关技术措施方式获取数据及报表，积加应在其网络系统内建立合理的安全体系，包括身份识别体系、内部安全防范体系，以使您数据尽可能完整，并且保密。积加无法杜绝全部的非安全因素，但积加会及时更新体系，妥善维护网络及相关数据。</span>
          </p>
          <p line="NmGA" class="ql-text-indent-1"><span
              class="up-font-microsoftyahei">3、积加将采取保密措施存储您信息，非经您书面同意，不得向任何第三方泄漏。以下信息除外：1）非由于积加的原因已经为公众所知的；2）由于积加以外其他渠道被他人获知的信息，这些渠道并不受保密义务的限制；3）由于法律的使用，法院或其他国家有权机关的要求而披露的信息。</span>
          </p>
          <p line="NmGA" class="ql-text-indent-1"><span
              class="up-font-microsoftyahei">4、由于以下原因引起的系统错误或损坏，积加无须承担任何责任：1）因您自身过错或过失而导致您用户登录名或密码泄漏所造成的损害或损失；2）由火灾、盗窃、黑客攻击和（或）其他不可抗力因素所造成的损害或损失；</span>
          </p>
          <p line="NmGA" class="ql-text-indent-1"><span
              class="up-font-microsoftyahei">5、如出现下列情况之一的，积加有权单方终止本合同，且积加无需向您退还其未履行部分的合同价款：1）您逾期15个工作日未向积加支付到期款项的；2）未经积加书面同意，您许可他人使用积加软件或转让积加软件使用许可的；3）您被认定为违法违规对外贸易经营者的；4）您违反本合同其他规定，且自积加通知其纠正后仍未纠正的。</span>
          </p>

          <p line="e76r"><br></p>
          <p line="tFD2"><strong class="up-font-microsoftyahei">三、收费服务</strong></p>
          <p line="NmGA" class="ql-text-indent-1"><span
              class="up-font-microsoftyahei">1、积加软件可能会根据不同的产品及服务类型推出不同的增值服务，积加软件也可能会根据用户的需求、产品及服务类型的变化等，对现有增值服务种类进行调整以及不断推出新的增值服务种类。积加软件也可能会在不同时间推出具体不同的服务内容，以不断完善、优化本服务。具体增值服务种类及服务内容以积加相关服务页面公布、实际提供的内容为准。您可以自行根据需要选择相应服务。</span>
          </p>
          <p line="NmGA" class="ql-text-indent-1"><span
              class="up-font-microsoftyahei">2、您所享有的本服务的具体内容可能会因为套餐级别、开通期限、选择的具体服务类别等因素而有不同，通常高级别、开通期限较长等情况下，您将会享有更多的服务，具体以积加相关服务页面公布、实际提供的内容为准。</span>
          </p>

          <p line="e76r"><br></p>
          <p line="tFD2"><strong class="up-font-microsoftyahei">四、保密信息的范围</strong></p>
          <p><span class="up-font-microsoftyahei">我们保密信息是指双方各自专有的、且提供给对方的并明确标有“保密”字样的信息，包括但不限于本合同及其签订、许可软件、数据，以及积加
              ERP
              使用过程中形成各种数据和相关信息等，或双双方承认保密信息构成有价值的商业秘密。双方一致确认严格按照本合同的规定使用对方的保密信息，未经对方的事先书面许可，不得向第三方，或允许向第三方直接或间接地透露保密信息，无论本合同是否变更、解除或终止，本条款始终有效。 </span>
          </p>
          <p><span class="up-font-microsoftyahei">1、保密信息包括但不限于：</span>
          </p>
          <p><span class="up-font-microsoftyahei">（1）数据库所有的数据；</span>
          </p>
          <p><span class="up-font-microsoftyahei">（2）客户或潜在客户的身份及其他相关信息、客户联系方式和客户销售策略等；</span>
          </p>
          <p><span class="up-font-microsoftyahei">（3）市场研究结果，市场渗透资料，及其他市场信息；</span>
          </p>
          <p><span class="up-font-microsoftyahei">（4）销售和市场计划、规划及策略；</span>
          </p>
          <p><span class="up-font-microsoftyahei">（5）销售额、成本和其他财务数据；</span>
          </p>
          <p><span class="up-font-microsoftyahei">（6）产品及服务的供应源（如供应商信息等）；</span>
          </p>
          <p><span class="up-font-microsoftyahei">（7）任何其他秘密工艺、配方或方法。</span>
          </p>

          <p><span class="up-font-microsoftyahei">2、保密信息不包括以下信息：</span>
          </p>
          <p><span class="up-font-microsoftyahei">（1）您已经公布于众的资料，但不包括双双方或其代表违反本协议规定未经授权所披露的；</span>
          </p>
          <p><span
              class="up-font-microsoftyahei">（2）我方已经独立开发的及未曾违反任何法律、法规或您的任何权利的信息，并且该等信息是在我方依照本协议条款从您获悉该等信息之前独立开发的；</span>
          </p>
          <p><span class="up-font-microsoftyahei">（3）我方在依照本协议条款从您获悉之前已经合法占有的信息，并且就我方所知我方并不需要对该等信息承担任何具有约束力的保密义务；</span>
          </p>
          <p><span class="up-font-microsoftyahei">（4）在双方签订本协议以后并非由于我方的过错而被公众所知的信息；</span>
          </p>
          <p><span class="up-font-microsoftyahei">（5）我方在未违反其对您承担的任何义务的情况下从第三方获得的信息。</span>
          </p>

          <p line="RfKW"><br></p>
          <p line="HeEK"><strong class="up-font-microsoftyahei">五、保密信息的使用</strong></p>
          <p><span
              class="up-font-microsoftyahei">1、所有保密信息双方均应做到最严格的保密，除为促进系统落地使用，或本协议允许的用途外，不得使用该等保密信息。在履行上述义务时，双方均应采取不低于与保护其自身保密信息所用措施同样严格的措施，
              并责成其每一位有可能得到保密信息的同事、管理人员、雇员或代理人分别就本协议涉及的保密内容签订一份与本协议所列条款同样严格的保密协议。</span>
          </p>
          <p><span style="background-color: unset;">2、除非事先取得对方的书面同意，否则相对方不得复制、出版或向第三方披露任何保密信息。</span>
          </p>
          <p><span style="background-color: unset;">3、如果具有司法管辖权的法庭或政府主管部门要求任一方披露保密信息，拟披露方</span>
          </p>
          <p line="kQTX"><br></p>
          <p line="7327"><strong class="up-font-microsoftyahei">六、违约责任</strong></p>
          <p line="t20L"><span
              style="background-color: unset;">1、违约责任明确的处理方式：如一方违反本协议中的任何条款，守约方可在此后的任何时间向违约方发出书面通知。如在该通知发出您10您个工作日之内违约方没有改正措施，违约方赔偿守约方直接损失，如本合同另有条款约定且明确约定违约情形、违约金额或损失赔偿金额等内容的，按照相应条款确定的违约情形、违约金额或损失赔偿金额等执行。</span>
          </p>
          <p line="t20L"><span
              style="background-color: unset;">2、违约责任不明确的处理方式：如果本合同约定的各方责任和义务未约定或未明确违约责任的，则任何一方未履行本合同或违反约定且该方未及时改正或采取补救措施的，或者任何一方未履行本合同或违反约定且该方采取了改正或采取补救措施但仍给合同相对方造成经济损失的，均视为该方违约，该方应当承担违约金和损失赔偿责任。</span>
          </p>
          <p line="t20L"><span
              style="background-color: unset;">3、权利不行使不视为放弃权利：一方未行使、迟延行使或部分行使其权利，并不意味该权利被放弃；某一权利不行使并不意味着其它权利被放弃。</span>
          </p>



          <p line="qkOs"><br></p>
          <p line="NkbE"><strong class="up-font-microsoftyahei">七、免责条款</strong></p>
          <p><span
              style="background-color: unset;">1、合同签订任何一方因战争、火灾、水灾、台风、交通事故、地震等国际惯例视作不可抗力受阻而无法履行其合同义务时，本合同执行时程将延长与上述事故持续时间相等之日数；</span>
          </p>
          <p line="ELoU"><span
              style="background-color: unset;">2、因不可抗力致使无法履行义务一方应立即以传真或电子邮件通知对方，并于不可抗力发生后14天内，以挂号信函或其他可及时通知对方的方式寄送当地主管机构核发之证明以证实该不可抗力之发生；</span>
          </p>
          <p><span style="background-color: unset;">3、因不可抗力致使无法履行义务一方应于该不抗力事件终止或排除后，立即以电子邮件、传真等方式通知他方，并提供相关的证明文件；</span>
          </p>
          <p line="ELoU"><span style="background-color: unset;">4、如不可抗力影响合同执行超过 3天，双方应就合同的进一步履行与否进行磋商并达成一致。</span>
          </p>

          <p line="IyVk"><br></p>
          <p line="jCBU"><strong class="up-font-microsoftyahei">八、争议解决</strong></p>
          <p line="f5Se"><span class="up-font-microsoftyahei">1、双方任何一方不履行本合同，或履行中违反合同要求的，则违约方需向守约方承担违约责任。</span></p>
          <p line="k4zW"><span
              class="up-font-microsoftyahei">2、合同中的未尽事宜，双方在执行中协商解决，协商不成的，向深圳市积加跨境网络科技有限公司所在地人民法院提起诉讼。诉讼费用应由败诉方承担，除非判决书或调解书另有裁定。</span>
          </p>

          <p line="IyVk"><br></p>
          <p line="RCiB">其他未尽事宜，以积加官网或通过其他渠道发布的产品使用规则或相关文件为准。</p>
        </div>
      </div>
    </template>
    <template #footer>
      <div style="text-align: center;">
        <gj-button type="primary" @click="agreed">
          同意并继续
        </gj-button>
      </div>
    </template>
  </gj-modal>
</template>

<script>
import { modalMixIn } from "../../../../../minxins";

export default {
  name: "service-agreement",
  mixins: [modalMixIn],
  methods: {
    agreed() {
      this.$emit('agreed');
      this.$gjDestroy();
    }
  }
}
</script>

<style scoped>
.up-container {
  font-family: -apple-system, "PingFang SC", "Hiragino Sans GB", "Source Han Sans SC", "Noto Sans CJK SC", "Microsoft YaHei", "WenQuanYi Micro Hei", "SimHei", sans-serif;
  padding: 10px 30px;
}

.up-container * {
  box-sizing: border-box;
}

.up-container .up-editor {
  font-size: 14px;
  line-height: 1.7;
  color: #494949;
  outline: none;
  -webkit-font-smoothing: antialiased;
  text-align: left;
  white-space: pre-wrap;
}

.up-container .up-editor .ql-text-indent-1 {
  text-indent: 2em;
}

.up-container .up-editor ul[data-list-style] {
  list-style-type: none;
}

.up-container .up-editor ul,
.up-container .up-editor p {
  margin: 0;
  padding: 0;
}

.up-container .up-editor .up-font-microsoftyahei {
  font-family: "Microsoft YaHei", sans-serif !important;
}

.up-container .up-editor ul>li {
  padding-left: 26px;
  list-style-type: inherit;
}

.up-container .up-editor ul[data-list-style]>li::before {
  margin-right: 0;
}

.up-container .up-editor ul[data-list-style]>li::before {
  width: 6px;
  height: 6px;
  margin-left: -26px;
  line-height: 1;
  margin-right: 15px;
  margin-bottom: 3px;
  box-sizing: border-box;
}

.up-container .up-editor ul[data-list-style='circle']>li::before {
  content: '';
  background: #000;
  border-radius: 50%;
}

.up-container .up-editor li::before {
  display: inline-block;
  white-space: nowrap;
}

@media (max-width: 864px) {
  .up-container {
    padding: 10px !important;
  }

  /deep/ .gj-modal--global {
    padding: 1.5rem 0.6rem !important;
  }
}
</style>





